import React, { Component } from 'react';
import './WelcomePanel.css';
import linkedInIcon from './res/In-2C-28px-R.png';
import twitterIcon from './res/Twitter_Social_Icon_Circle_Color.svg';
import githubIcon from './res/GithubIcon.png';
export const id = 'welcomePanel';

class WelcomePanel extends Component {
  componentDidMount() {

  }
  render() {
    const { isMobile } = this.props;
    
    const arrowDiretionClassname = isMobile ? 'fa-arrow-right' : 'fa-arrow-down'; 
    const arrowPositionClassname = isMobile ? 'bounceHorizontal arrowMobilePosition' : 'bounce arrowPosition'
    const arrow = isMobile ? (
        <div className={`arrow ${arrowPositionClassname}`}>
          <span className={`fa fa-2x ${arrowDiretionClassname}`}></span>
        </div>
      ) :
      (
        <div className={`arrow ${arrowPositionClassname}`}>
          <span className={`fa fa-2x ${arrowDiretionClassname}`}></span>
        </div>
      );

    return (
      <div className="WelcomePanel" id={id}>
        <div className="WelcomePanelBlurb">
          <div>
            Lyndsey Ferguson
            <p/>
            <a href="https://twitter.com/lyndseydf?ref_src=twsrc%5Etfw"
               className="twitter-follow-button" 
               style={{ color: '#FFFFFF' }} 
               data-show-count="false" >
              <img src={twitterIcon} width='28' alt='Twtter Logo'/>
            </a>
            <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
            &nbsp; &nbsp;
            <a style={{textDecoration: 'none', align: 'right'}} 
               href="https://www.linkedin.com/in/lyndsey-ferguson-25001522/">
               <img src={linkedInIcon} alt='Linkedin Logo' />
            </a>
            &nbsp;
            <a style={{textDecoration: 'none'}}
              href="https://github.com/lyndsey-ferguson">
              <img src={githubIcon} width='28' alt='Github Logo'/>
            </a>
          </div>
        </div>
        {arrow}
      </div>
    );
  }
}

export default WelcomePanel;



// WEBPACK FOOTER //
// ./src/WelcomePanel.js